<template>
  <v-select
    :rules="selectErrors()"
    :label="label"
    :items="selectOptions"
    :item-text="'hint'"
    :item-value="'value'"
    :height="'44'"
    :color="'#00BFB3'"
    :background-color="'#EFEFEF'"
    :value="value"
    v-on:input="$emit('input', $event)"
    :model="value"
  ></v-select>
</template>

<script>
import Vue from "vue";

export default {
  name: "custom-select",
  methods: {
    selectErrors() {
      if (this.required == false) { return [true] }
      if (this.value.length == 0) {
        return ["Campo obrigatório"];
      }
      return [true];
    }
  },
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    },
    submited: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    }
  },
  computed: {
    selectOptions() {
      return this.options.map($0 => {
        return { hint: $0.hint, value: $0.value };
      });
    }
  }
};
</script>
<style lang="scss">
.v-select__selections {
  padding-left: 10px;
  padding-right: 10px;
}
select {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #efefef;
  outline: none;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Select.vue